var config = {
  parserURL: 'http://127.0.0.1:5000/missions-parse'
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/jsx/config/development.config.jsx